module.exports = __webpack_public_path__ + "img/hik-niro-cam.f1c697bc.png";